"use client";

import { c as _c } from "react/compiler-runtime";
import { Divider } from "@dc/ui/components";
import { useTranslations } from "next-intl";
import type { FC } from "react";
import { ClockCircleLinear, ShieldUserLinear } from "solar-icon-set";
import { useAbility } from "@/hooks/useAbility";
import { useFeatureFlags } from "@/hooks/useFeatureFlags";
import { MenuRow } from "./MenuRow";
import { MenuSectionLabel } from "./MenuSectionLabel";
import type { MenuSectionProps } from "./UserSettingsSection";
export const InternalToolsSection: FC<Pick<MenuSectionProps, "onNavigate">> = t0 => {
  const $ = _c(22);
  const {
    onNavigate
  } = t0;
  const t = useTranslations("navigation");
  const {
    can,
    isLoading
  } = useAbility();
  const flags = useFeatureFlags();
  if (isLoading) {
    return null;
  }
  let t1;
  if ($[0] !== can || $[1] !== flags) {
    t1 = Boolean(flags["trials-enable-provisioning-pd-6"]) && can("read", {
      scopeType: "TRIAL"
    });
    $[0] = can;
    $[1] = flags;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const canTrials = t1;
  let t2;
  if ($[3] !== can) {
    t2 = can("manage", {
      scopeType: "SYSTEM"
    });
    $[3] = can;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const canSystemAdmin = t2;
  if (!canTrials && !canSystemAdmin) {
    return null;
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Divider />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("actions.internal_tools");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <MenuSectionLabel>{t4}</MenuSectionLabel>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== canTrials || $[11] !== onNavigate || $[12] !== t) {
    t6 = canTrials && <MenuRow icon={<ClockCircleLinear className="size-5" />} label={t("org_switcher.trials")} onPress={() => onNavigate("/trials")} testId="sidebar-trials" trackingLabel="Trials" />;
    $[10] = canTrials;
    $[11] = onNavigate;
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== canSystemAdmin || $[15] !== onNavigate || $[16] !== t) {
    t7 = canSystemAdmin && <MenuRow icon={<ShieldUserLinear className="size-5" />} label={t("actions.system_admin")} onPress={() => onNavigate("/settings/admin/organizations")} testId="sidebar-system-admin" trackingLabel="System Admin" />;
    $[14] = canSystemAdmin;
    $[15] = onNavigate;
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t8 = <>{t3}<div className="flex w-full flex-col p-2" data-testid="sidebar-internal-tools">{t5}{t6}{t7}</div></>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};